import { render, staticRenderFns } from "./DomainsView.vue?vue&type=template&id=d734b2fa&"
import script from "./DomainsView.vue?vue&type=script&lang=js&"
export * from "./DomainsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports